import React, { Component } from 'react'
import "./result.scss"
import Header from '../../components/Header/header'
import Footer from '../../components/Footer/footer'
import { getApiPolicyList } from "../../axios/api"


export default class result extends Component {


    state = {
        banner:[],
        list:[],

        currentIndex:0,
        nIndex:0,

        newsType:1,

        page:1,
        total:1,

        key:"",

        showMore:false,
    }

    componentWillMount(){
        window.scroll(0,0);
    }

    componentDidMount(){
        // getApiBanner({type:2})
        // .then( req =>{
        //     if(req.data.code === 1){
        //         this.setState({
        //             banner:req.data.data
        //         })
        //     }
        // }).catch( err =>{
        //     console.error(err);
        // })
        // this.getList();
    }

    onChange=(index)=>{
        this.setState({
            currentIndex:index
        })
    }

    changePage=(page)=>{
        this.setState({
            page
        })

    }

    gotoSlide=(num)=>{
        this.refs['bslide'].goTo(num);
    }

    gotoPage=(page)=>{
        this.props.history.push(page);
    }



    getList=()=>{
        let param = {
            keywords:this.state.key,
            page:this.state.page,
        }

        getApiPolicyList(param)
        .then( req =>{
            if(req.data.code === 1){
                let data = req.data.data;
                this.setState({
                    list:data.list,
                    total:data.total
                })
            }
        }).catch( err =>{
            console.error(err);
        })
    }

    render() {
        return (
            <div className='result'>
                <Header type={2} />
                <div className='head'>
                    <div className='cen'>
                        <div className='hmain'>
                            <div className='hname'>
                                <p>当前位置：</p>
                                <p className='i_point' onClick={()=>{this.gotoPage('/')}}>首页</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p className='i_point' onClick={()=>{this.gotoPage('/result')}}>高企测评</p>
                                <img alt="" src="/www/assets/imgs/xiaji.png" />
                                <p>高企测评结果</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='hnum'>
                    <div className='cen'>
                        <div className='hmain'>
                            <button className='btn1'>下载报告</button>
                            <button className='btn2'>重新测评</button>
                            <div className='htext'>
                                <h4>总分   <span>78.92分</span></h4>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='hpage'>
                    <div className='cen'>
                        <div className='hmain'>
                            <table>
                                <thead>
                                    <tr className='trh'>
                                        <th className='tfd'>分类名称</th>
                                        <th>分数</th>
                                    </tr>
                                    <tr className='trh2'>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                
                                <tbody>
                                    <tr>
                                        <td className='tfd'>知识产权得分</td>
                                        <td className='blue'>20.01 分</td>
                                    </tr>
                                    <tr>
                                        <td className='tfd'>成果转化得分</td>
                                        <td className='blue'>30.20 分</td>
                                    </tr>
                                    <tr>
                                        <td className='tfd'>管理水平得分</td>
                                        <td className='blue'>12.09 分</td>
                                    </tr>
                                    <tr>
                                        <td className='tfd'>财务增长性得分</td>
                                        <td className='blue'>16.62 分</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
